import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			networkMode: "offlineFirst",
			retry: false,
			// staleTime: 60_000, // 1 minute
			// gcTime: 300_000, // 5 minutes - DEFAULT
		},
		mutations: {
			networkMode: "offlineFirst",
			retry: false,
			// gcTime: 300_000, // 5 minutes - DEFAULT
		},
	},
});

export const QueryProvider = ({ children }) => {
	return (
		<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
	);
};
